import { OperatorNoteInput } from "#models/Configurator"
import { mdiFileDocument, mdiFileDocumentPlusOutline } from "@mdi/js"
import * as S from "effect-app/Schema"

// Same limit as the stored note (NonEmptyString2k).
export const NOTE_MAX_LENGTH = 2 * 1024

// The note dialog is an OmegaForm on the same field the Set*Note commands take.
// Being nullable, it is not required and a cleared field is sent as null, which
// removes the note.
export const OperatorNoteForm = S.Struct({ note: OperatorNoteInput })

// The row button: "add" while empty, a filled document in the accent colour once
// there is a note.
export const noteButton = (note: string | null) =>
  note === null
    ? { icon: mdiFileDocumentPlusOutline, tooltip: "Notiz hinzufügen", hasNote: false }
    : { icon: mdiFileDocument, tooltip: "Notiz anzeigen", hasNote: true }

// On a detail page the note field stays out of the way until there is a note or
// the operator asks for one ("Notiz hinzufügen").
export const isNoteFieldShown = (opened: boolean, savedNote: string | null) => opened || savedNote !== null

// Every way out of the note dialog (Abbrechen, Escape, a click outside) goes
// through one close: nothing while a save runs (its success closes the dialog,
// and it must not close a note opened meanwhile), a confirmation before typed
// text is thrown away, otherwise it just closes.
export const noteDialogClose = (state: { saving: boolean; dirty: boolean }): "keep" | "confirm" | "close" =>
  state.saving ? "keep" : state.dirty ? "confirm" : "close"
